import { TextField, Box, Snackbar, Alert } from '@mui/material';
import { Button as ShellButton } from 'components/AppShell';
import AppSelect from 'components/AppSelect';
import { useState } from 'react';

export default function Validate() {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // default to success

  const [text, setText] = useState('');

  const [ver, setVer] = useState(null);

  const data = [
    {
      id: 0,
      name: 'ТЗ v1',
    },
    {
      id: 1,
      name: 'ТЗ v2',
    },
  ];

  const handleSave = () => {
    // Simulate success
    setSnackbarMessage(`Успешно провалидировано` /*: ${inputValue} */);
    setSnackbarSeverity('success'); // explicitly set to success
    setSnackbarOpen(true);

    // Reset input field (optional)
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const handlePrompt = (event) => {
    setText(event.target.value);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, p: 2, width: '100%' }}>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <TextField
        id="validate-text"
        label="ТЗ"
        multiline
        rows={24}
        fullWidth
        size="small"
        value={text}
        onChange={handlePrompt}
        variant="outlined"
        placeholder="Вставьте текст ТЗ для валидации…"
      />

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <AppSelect
          sx={{ width: 240 }}
          size="small"
          options={data}
          value={ver}
          onChange={(_, newValue) => setVer(newValue)}
          getOptionLabel={(option) => option.name || ''}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          label="Выбранная версия"
          noOptionsText="Нет версий"
        />
        <ShellButton variant="primary" onClick={handleSave}>
          Валидировать
        </ShellButton>
      </Box>
    </Box>
  );
}
